import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';

function NotFoundPage() {
    return (
        <Result
            status="404"
            title="Page not found"
            subTitle="This URL is not registered in the admin app."
            extra={
                <Link to="/">
                    <Button type="primary">Back to home</Button>
                </Link>
            }
        />
    );
}

export default NotFoundPage;
